import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *我的团队定位信息
 * @param params
 * 
*/

export const myTeamInfo = params => Http.get(`${baseUrl}/sz/team/dw/my`, { params })

/**
 *修改我的团队定位信息
 * @param params
 * 
*/

export const submitInfo = params => Http.post(`${baseUrl}/sz/team/dw/submit`,  params )

/**
 *团队成果
 * @param teamId
 * 
*/

export const result = teamId => Http.get(`${baseUrl}/sz/team/dw/${teamId}`)